import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';

import { setModoTela, initForm } from './grupoProdutoActions';
import labelAndInputMask from '../common/form/labelAndInputMask';
import ClienteUtils from '../common/utils/ClienteUtils';

class GrupoProdutoForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Select
								name='ids_produtos'
								options={this.props.listaProduto}
								label='Produtos'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly}
								multiple
								value={this.props.formularioValues.ids_produtos}
								onChange={values => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_produtos: values.map(item => item.value)
									});
								}} />

							<Select
								name='ids_usuarios'
								options={this.props.listaUsuario}
								label='Vendedores'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly}
								multiple
								value={this.props.formularioValues.ids_usuarios}
								onChange={values => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_usuarios: values.map(item => item.value)
									});
								}} />
						</Row>						
						
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

GrupoProdutoForm = reduxForm({form: 'grupoProdutoForm', destroyOnUnmount: false})(GrupoProdutoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('grupoProdutoForm')(state),
	registro: state.grupoProduto.registro,
	listaProduto: state.produto.listaSelect,
	listaUsuario: state.usuario.listaSelect.filter(item => item.id_vendedor)
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(GrupoProdutoForm);
